import { useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

const EnvColor = ({ env, alwaysRender = false }) => {
    const mount = useRef(true);
    useLayoutEffect(() => {
        if (mount.current || alwaysRender) {
            const strippedClassName = document.body.className
                .replace(
                    /(\bprod\b)|(\buat\b)|(\bqa\b)|(\bdev\b)|(\blocal\b)/,
                    ''
                );
            document.body.className = `${strippedClassName} ${env}`;
            mount.current = false;
        }
    });

    return (
        null
    );
};

EnvColor.propTypes = {
    alwaysRender: PropTypes.bool,
    env: PropTypes.string
};

EnvColor.defaultProps = {
    alwaysRender: false,
    env: null
};

export default EnvColor;
